import { AuthenticatedTemplate } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { getAnnouncementHighlight } from '../../../services/ApiGetAnnouncementHighlight';
import { GetAnnouncement } from '../../../model/datatype';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const NewsHighlight = (prop: any) => {
  let { t } = useTranslation();
  let navigate = useNavigate();
  const [data, setData] = useState<GetAnnouncement | null>(null);
  useEffect(() => {
    if (data === null) {
      getAnnouncementHighlight().then((response) => {
        const getData: any = response;
        //console.log(getData);
        setData(getData);
      });
    }
  }, [data]);

  let URL = undefined;
  if (data?.thumnail !== undefined) {
    URL = 'data:image/jpg;base64,' + data?.thumnail;
  }

  const handleGoToDetail = () => {
    navigate('/anouncement/' + data?.id, { state: data });
  };

  //console.log(data?.thumnail);

  const subjectEn = data?.subjectEn !== null ? data?.subjectEn : '';
  const subjectTh = data?.subjectTh !== null ? data?.subjectTh : '';
  const shortDetailsTh =
    data?.shortDetailsTh !== null ? (
      data?.shortDetailsTh
    ) : (
      <div className="text-center">{t('message_data')}</div>
    );
  const shortDetailsEn =
    data?.shortDetailsEn !== null ? (
      data?.shortDetailsEn
    ) : (
      <div className="text-center">{t('message_data')}</div>
    );
  //console.log('shortDetailsTh=', data?.shortDetailsEn);
  //console.log('shortDetailsTh=', data?.shortDetailsTh);
  return (
    <>
      {data ? (
        <div className="news-highlight-box" onClick={() => handleGoToDetail()}>
          <Container className="px-0">
            <Row>
              <Col className="col-5 col-sm-3 col-md-3 col-lg-3">
                <div className="news-highlight">
                  <img
                    src={`${
                      data?.thumnail === undefined || data?.thumnail === null
                        ? '/images/no_images.png'
                        : URL
                    }`}
                    className="img-fluid hover-shadow rounded"
                  />
                </div>
              </Col>
              <Col className="pl-0 col-7 col-sm-9 col-md-9 col-lg-9 p-relative pb-4">
                <div className="news-highlight-detail">
                  <h3 className="news-highlight-title">
                    {localStorage.getItem('Language') === 'en'
                      ? subjectEn
                      : subjectTh}
                  </h3>
                  <div className="highlight-detail">
                    {localStorage.getItem('Language') === 'th' &&
                    shortDetailsTh !== null
                      ? shortDetailsTh
                      : shortDetailsEn}
                  </div>
                </div>
                {data?.thumnail !== null ? (
                  <div className="news-highlight-readmore">{t('readmore')}</div>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
